"use client";

import { motion, useReducedMotion } from "framer-motion";

import { cn } from "@/lib/utils";

import type { MockupVariant } from "./MockupScene.types";

type MockupAccentStreaksProps = {
  variant?: MockupVariant;
};

export const MockupAccentStreaks = ({
  variant = "light",
}: MockupAccentStreaksProps) => {
  const prefersReducedMotion = useReducedMotion();
  const isDark = variant === "dark";

  return (
    <div
      className="pointer-events-none absolute inset-0 overflow-hidden"
      aria-hidden
    >
      <motion.div
        className={cn(
          "absolute -left-8 bottom-0 h-px w-[140%] rotate-[-24deg] origin-left",
          isDark
            ? "bg-gradient-to-r from-transparent via-rose-400/25 to-transparent"
            : "bg-gradient-to-r from-transparent via-rose-300/40 to-transparent",
        )}
        animate={
          prefersReducedMotion ? undefined : { opacity: [0.35, 0.7, 0.35] }
        }
        transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className={cn(
          "absolute -right-12 top-8 h-px w-[120%] rotate-[-18deg] origin-right",
          isDark
            ? "bg-gradient-to-r from-transparent via-violet-400/30 to-transparent"
            : "bg-gradient-to-r from-transparent via-violet-400/35 to-transparent",
        )}
        animate={
          prefersReducedMotion ? undefined : { opacity: [0.25, 0.55, 0.25] }
        }
        transition={{
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.8,
        }}
      />
      <motion.div
        className={cn(
          "absolute right-0 top-1/3 h-px w-[80%] rotate-[-12deg] origin-right",
          isDark
            ? "bg-gradient-to-r from-transparent via-amber/20 to-transparent"
            : "bg-gradient-to-r from-transparent via-amber/30 to-transparent",
        )}
        animate={
          prefersReducedMotion ? undefined : { opacity: [0.2, 0.45, 0.2] }
        }
        transition={{
          duration: 7,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 1.2,
        }}
      />
    </div>
  );
};
